module.exports = __webpack_public_path__ + "img/textalign-justifyright.dfbd0093.svg";